import { useEffect, useState } from 'react';

// The backend owns the enable flag; keep one lookup for each loaded portal page.
let enabledRequest: Promise<boolean> | undefined;

export default function useSsoLabel(email: string, active = true) {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (!enabledRequest) {
      enabledRequest = fetch(
        new URL('/public/auth/config', import.meta.env.VITE_API_URL)
      )
        .then((response) => {
          if (!response.ok) throw new Error('Unable to load sign-in settings');
          return response.json();
        })
        .then((data) => data.nusOidcEnabled === true)
        .catch(() => false);
    }
    let current = true;
    enabledRequest.then((value) => {
      if (current) setEnabled(value);
    });
    return () => {
      current = false;
    };
  }, []);

  const normalizedEmail = email.trim().toLowerCase();
  return (
    active &&
    enabled &&
    (normalizedEmail.endsWith('@nus.edu.sg') ||
      normalizedEmail.endsWith('@u.nus.edu'))
  );
}
